export default __webpack_public_path__ + "static/media/games.303497c1.svg";